module.exports = __webpack_public_path__ + "static/media/tyre-red-four4.3d027858.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-red-four4.png
// module id = 344
// module chunks = 0